"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var consts_1 = require("../consts");
var removeSpecialCharacters_1 = require("./removeSpecialCharacters");
// Add not-available value if the datalayer object value is empty
var checkDataLayerValueEmpty = function (datalayer) {
    for (var key in datalayer) {
        if (datalayer.hasOwnProperty(key) && typeof datalayer[key] === "object") {
            checkDataLayerValueEmpty(datalayer[key]);
        }
        if (typeof datalayer[key] !== "object") {
            if (key !== "targetURL") {
                var newVal = (0, removeSpecialCharacters_1.default)(datalayer[key]);
                datalayer[key] = newVal;
            }
            if (key === "targetURL" && datalayer[key] !== "" && datalayer[key] !== undefined && datalayer[key] !== consts_1.NOT_AVAILABLE) {
                if (datalayer[key].includes("http://") || datalayer[key].includes("https://")) {
                    // Dont add the origin path
                }
                else {
                    datalayer[key] = "".concat(window.location.origin).concat(datalayer[key]);
                }
            }
            if (datalayer[key] === "" || datalayer[key] === undefined) {
                datalayer[key] = consts_1.NOT_AVAILABLE;
            }
        }
        if (datalayer[key] === null || datalayer[key] === undefined) {
            datalayer[key] = consts_1.NOT_AVAILABLE;
        }
        if (Array.isArray(datalayer[key])) {
            var arrNest = datalayer[key];
            for (var i = 0; i < arrNest.length; i++) {
                checkDataLayerValueEmpty(arrNest[i]);
            }
        }
    }
    return datalayer;
};
exports.default = checkDataLayerValueEmpty;
